import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import { Table, DatePicker, Modal } from 'antd';
import Pagination from 'rc-pagination';
import moment from 'moment';
import Select from 'react-select';
import { SERVER_URL } from './../../../../config/host';
import * as actionScoreLog from './../../../../actions/scoreLog';
import * as actionUser from './../../../../actions/user';

import './../../style.css';

@connect(
  state => ({
    scoreLogState: state.get('ScoreLog'),
    userState: state.get('User')
  }),
  dispatch => ({
    scoreLogAction: bindActionCreators(actionScoreLog, dispatch),
    userAction: bindActionCreators(actionUser, dispatch)
  })
)

export default class Score extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      scoreList: {},
      loading: false
    };
  }
  state = { visible: false }
  componentWillMount() {
    const { scoreLogAction, userAction } = this.props;
    userAction.fetchGetUserName();
    scoreLogAction.fetchgetScoreLog({ page: this.state.page, limit: this.state.limit })
      .then(() => { this.handleData(); })
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { userState, scoreLogState } = nextProps;
    const { data } = (userState && userState.toJS().data) || {};
    const exportData = (scoreLogState && scoreLogState.toJS().export.data) || false;
    this.setState({ userName: data, exportData: exportData });
  }
  // 设置时间
  setDate = (value) => {
    let bgTime;
    if (value._d) {
      bgTime = moment(value._d).format('YYYY-MM-DD');
    }
    this.setState({
      bgTime: bgTime || ''
    })
  }
  setDate1 = (value) => {
    let endTime;
    if (value._d) {
      endTime = moment(value._d).format('YYYY-MM-DD');
    }
    this.setState({
      endTime: endTime || ''
    })
  }
  // 设置状态
  setUser = (value) => {
    this.setState({
      user: (value && value.id) || ''
    })
  }
  handleData = () => {
    const { scoreLogState } = this.props;
    const { data } = scoreLogState.toJS().data;
    this.setState({ scoreList: data });
  };
  // 弹窗控制
  handleOk = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  handleCancel = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  search = () => {
    const { page, limit, user, bgTime, endTime } = this.state;
    const { scoreLogAction } = this.props;
    scoreLogAction.fetchgetScoreLog({ page: page, limit: limit, userId: user, bgTime: bgTime, endTime: endTime })
      .then(() => { this.handleData(); })
  }
  export = () => {
    const { scoreLogAction, scoreLogState } = this.props;
    this.setState({ loading: true });
    const { user, bgTime, endTime } = this.state;
    scoreLogAction.fetchGetScoreLogExport({ id: user, bgTime: bgTime, endTime: endTime })
      .then(() => {
        const loaded = scoreLogState && scoreLogState.get('loaded');
        this.setState({ loaded: loaded, loading: false });
      })
  }
  pageChange = (page) => {
    this.setState({ page: page })
    const { limit, user, bgTime, endTime } = this.state;
    const { scoreLogAction } = this.props;
    scoreLogAction.fetchgetScoreLog({ page: page, limit: limit, userId: user, bgTime: bgTime, endTime: endTime })
      .then(() => { this.handleData(); })
  }

  render() {
    const { scoreList, userName, user, exportData } = this.state;
    const columns = [
      { title: '用户', dataIndex: 'user.username', render: (text, record) => <div>{record.user.username}</div> },
      { title: '电话', dataIndex: 'user.phone', render: (text, record) => <div>{record.user.phone}</div> },
      { title: '经销商', dataIndex: 'user.name', render: (text, record) => <div>{record.user.name}</div> },
      { title: '时间', dataIndex: 'date' },
      { title: '积分', dataIndex: 'score' },
      { title: '类型', dataIndex: 'type' }];
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group">
                <Col md="4">
                  <Select
                    placeholder="用户名"
                    labelKey="name"
                    valueKey="id"
                    value={user || ''}
                    options={userName}
                    onChange={e => this.setUser(e)}
                  />
                </Col>
                <Col md="2">
                  <DatePicker
                    format="YYYY-MM-DD"
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="开始日期"
                    onChange={e => this.setDate(e)}
                  />
                </Col>
                <Col md="2">
                  <DatePicker
                    format="YYYY-MM-DD"
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="结束日期"
                    onChange={e => this.setDate1(e)}
                  />
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.search} className="btn btn-primary btn-pointer"><i className="fa fa-search" /> </button>
                  </span>
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.export} className="btn btn-primary btn-pointer">{this.state.visible ? '导出中' : '导出'} </button>
                  </span>
                  <Modal
                    visible={this.state.loaded}
                    title="提示"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                  >
                    <p>导出成功,请长按地址在浏览器打开</p>
                    <p>{SERVER_URL}/{exportData && exportData.data && exportData.data.downloadUrl}</p>
                  </Modal>
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md="12">
              <Table
                loading={this.state.loading}
                pagination={false}
                rowKey="id"
                bordered
                columns={columns}
                dataSource={scoreList.docs}
                showHeader="false"
                size="middle"
              />
              <div className="card-block" style={{ 'margin-left': 'auto', 'margin-right': 'auto' }}>
                <Pagination
                  showLessItems
                  current={this.state.page}
                  pageSize={this.state.limit}
                  onChange={this.pageChange}
                  showTotal={(total, range) => `${range[0]} - ${range[1]} 共 ${total} 条`}
                  total={scoreList.total}
                />
              </div>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Score/ScoreLog/index.js